import { ActionTree, ActionContext } from "vuex";
import { RootState } from "@/store";

import { State } from "./state";
import { Mutations } from "./mutations";
import { GeneralMutationTypes } from "./mutation-types";
import { GeneralActionTypes } from "./action-types";
import axiosAgsc from "@/store/axiosAgsc";
import apiIDserver from "@/store/axiosIdentity";
import { AuthActionTypes } from "../auth/action-types";
import { Roles } from "@/helpers/enums/Roles";
import moment from "moment";

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, "commit">;

export interface Actions {
  [GeneralActionTypes.SIDEBAR_STATUS](
    { commit }: AugmentedActionContext,
    payload: string // Obsolete in here but left as an example
  ): Promise<boolean>;
  [GeneralActionTypes.FILTER_STATUS](
    { commit }: AugmentedActionContext,
    payload: boolean // Obsolete in here but left as an example
  ): Promise<boolean>;
  [GeneralActionTypes.GET_COMPANIES](
    { commit }: AugmentedActionContext,
    payload: Array<any> // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.SET_AGMS_BREADCRUMB_STATUS](
    { commit }: AugmentedActionContext,
    payload: boolean // Obsolete in here but left as an example
  ): any;
  [GeneralActionTypes.SET_AGMS_BREADCRUMB_DATA](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): any;
  [GeneralActionTypes.SET_COMPKEY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): any;
  [GeneralActionTypes.SET_EXPORT_STATUS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): any;
  [GeneralActionTypes.SET_EXPORT_DATA_LOADED](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): any;
  [GeneralActionTypes.SET_ROW_OPENED](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): any;
  [GeneralActionTypes.SET_SELECTED_DECISION](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): any;
  [GeneralActionTypes.GET_SECTIONS]({
    commit,
  }: AugmentedActionContext): Promise<Array<any>>;
  [GeneralActionTypes.GET_SITES]({
    commit,
  }: AugmentedActionContext): Promise<Array<any>>;
  [GeneralActionTypes.GET_GROUPS]({
    commit,
  }: AugmentedActionContext): Promise<Array<any>>;
  [GeneralActionTypes.GET_COMPANY_ASSETS](
    { commit }: AugmentedActionContext,
    payload: Array<any> // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.GET_USERS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_PARTNERS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_EVENTS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_EVENT_LISTS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_ALERTS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_ASSETS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_ASSET_SITES](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_ASSET_GROUPS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_ASSET_COMPUTERS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_AUDITS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.DELETE_ASSET_COMPUTERS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_COMPUTER_LIST](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_COMPUTER_LIST_BY_USER](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_HASHES](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_PROPOSED_UNIQUE_BLOCKS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_PERMISSION_LEVELS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_REVIEW_STATUSES](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_RISK_LEVELS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_SETTINGS](
    { commit }: AugmentedActionContext,
    payload: string // Obsolete in here but left as an example
  ): Promise<void>;
  [GeneralActionTypes.GET_SMTP_SETTINGS](
    { commit }: AugmentedActionContext,
    payload: string // Obsolete in here but left as an example
  ): Promise<void>;
  [GeneralActionTypes.GET_GLOBAL_SETTINGS](
    { commit }: AugmentedActionContext,
    payload: string // Obsolete in here but left as an example
  ): Promise<void>;
  [GeneralActionTypes.UPDATE_SETTINGS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.UPDATE_SMTP_SETTINGS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.UPDATE_GLOBAL_SETTINGS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.UPDATE_REVIEW](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.CREATE_REVIEW](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.CREATE_UNIQUE_BLOCK_REVIEW](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.UPDATE_REVIEW_CHECKLIST_ITEM](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.SET_SELECTED_ROW](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.SET_SCOPE_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.GET_POLICY_CHECK_LIST](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_REVIEW_CHECK_LIST](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.CREATE_OTP](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.CREATE_OR_EDIT_COMPANY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.DELETE_COMPANY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_EVENT_POLICY_NAME](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_SERVERS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_GLOBAL_SERVER](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.CREATE_OR_UPDATE_SERVER](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.SELECT_OR_INHERIT_SERVER](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.DELETE_SERVER](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.DELETE_SELECT_SERVER](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_ZONES](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_SERVER_BY_ID](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_COMPANY_SERVER_BY_ID](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_TEST_CONNECTION_BY_SERVERID](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.TEST_CONNECTION](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.UPDATE_APPGUARD_MAIN](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_OR_CREATE_APPGUARD_MAIN](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.RESET_TO_DEFAULT_APPGUARD_MAIN](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.EDIT_PROCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_APPGROUPS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_APPGROUP_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

   [GeneralActionTypes.EXPORT_APPGROUP](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.IMPORT_APPGROUP](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_REGISTRY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_REGISTRY_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_REGISTRY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CODE_LOAD](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_CODE_LOAD_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_CODE_LOAD](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_CHILD_LAUNCH_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_CHILD_LAUNCH](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_FILE_ACCESS_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_FILE_ACCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_PROCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_PROCESS_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_PROCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_FOLDER_MAPS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_ENUM_BY_NAME](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_CHILD_LAUNCH](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_REGISTRY_ACCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_FILE_ACCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_CODE_LOAD](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_PUBLISHER_LIST](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_ALL_GLOBAL_POLICY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_GLOBAL_POLICY_REGISTRY_ACCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_GLOBAL_POLICY_REGISTRY_ACCESS_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_GLOBAL_POLICY_FILE_ACCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_GLOBAL_POLICY_REGISTRY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

   [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

   [GeneralActionTypes.GET_GLOBAL_POLICY_CODE_LOAD](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

   [GeneralActionTypes.DELETE_GLOBAL_POLICY_CODE_LOAD](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_PROCESS](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;
  [GeneralActionTypes.CREATE_OR_UPDATE_FILE_TYPES_POLICY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.GET_FILE_TYPES_POLICY_DETAIL](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_FILE_TYPES_POLICY](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
  [GeneralActionTypes.DELETE_FILE_TYPES_POLICY_DAO](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;

  [GeneralActionTypes.CREATE_OR_UPDATE_FILE_TYPES_POLICY_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_FILE_TYPES_POLICY_DAO_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;

  [GeneralActionTypes.GET_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;

  [GeneralActionTypes.GET_GLOBAL_POLICY_CODE_LOAD_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;

  [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUPS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<Array<any>>;

  [GeneralActionTypes.GET_APPGROUP_DETAIL_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_PROCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_PROCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_PROCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_FILE_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_FILE_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_REGISTRY_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_REGISTRY_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_REGISTRY_ACCESS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_CODE_LOAD_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CODE_LOAD_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_CODE_LOAD_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_APPGROUP_CHILD_LAUNCH_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.DELETE_APPGROUP_CHILD_LAUNCH_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;

  [GeneralActionTypes.GET_FILE_TYPES_POLICY_DETAIL_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<any>;
}

export const actions: ActionTree<State, RootState> & Actions = {
  async [GeneralActionTypes.SIDEBAR_STATUS]({ commit }, payload: string) {
    return new Promise(() => {
      commit(GeneralMutationTypes.SET_SIDEBAR_STATUS, payload);
    });
  },
  async [GeneralActionTypes.SET_AGMS_BREADCRUMB_STATUS](
    { commit },
    payload: boolean
  ) {
    commit(GeneralMutationTypes.SET_AGMS_BREADCRUMB_STATUS, payload);
  },
  async [GeneralActionTypes.SET_AGMS_BREADCRUMB_DATA](
    { commit },
    payload: any
  ) {
    commit(GeneralMutationTypes.SET_AGMS_BREADCRUMB_DATA, payload);
  },
  async [GeneralActionTypes.SET_COMPKEY]({ commit }, payload: any) {
    commit(GeneralMutationTypes.SET_COMPKEY, payload);
  },
  async [GeneralActionTypes.SET_EXPORT_STATUS]({ commit }, payload: any) {
    commit(GeneralMutationTypes.SET_EXPORT_STATUS, payload);
  },
  async [GeneralActionTypes.SET_EXPORT_DATA_LOADED]({ commit }, payload: any) {
    commit(GeneralMutationTypes.SET_EXPORT_DATA_LOADED, payload);
  },
  async [GeneralActionTypes.SET_ROW_OPENED]({ commit }, payload: any) {
    commit(GeneralMutationTypes.SET_ROW_OPENED, payload);
  },
  async [GeneralActionTypes.SET_SELECTED_DECISION]({ commit }, payload: any) {
    commit(GeneralMutationTypes.SET_SELECTED_DECISION, payload);
  },
  async [GeneralActionTypes.FILTER_STATUS]({ commit }, payload: boolean) {
    return new Promise(() => {
      commit(GeneralMutationTypes.SET_FILTER_STATUS, payload);
    });
  },
  async [GeneralActionTypes.LOADER_STATUS]({ commit }, payload: boolean) {
    return new Promise(() => {
      commit(GeneralMutationTypes.SET_LOADER_STATUS, payload);
    });
  },
  async [GeneralActionTypes.GET_COMPANY_ASSETS]({ commit }) {
    return new Promise(() => {
      axiosAgsc.get("Dashboard/GetCompanyAssets", null).then(response => {
        commit(
          GeneralMutationTypes.SET_COMPANY_ASSETS,
          response.data.entityData
        );
      });
    });
  },
  async [GeneralActionTypes.GET_SECTIONS]({ commit, dispatch, rootGetters }) {
    return new Promise(() => {
      axiosAgsc.get("User/GetUserClaimsInformation", {}).then(response => {
        if (!response.data.entityData) {
          return;
        }
        const companies = response.data.entityData.companies.map(
          (item: any) => {
            return {
              key: item.key,
              value: item.value,
              companyGuid: item.key,
              companyName: item.value,
            };
          }
        );

        const sites = response.data.entityData.sites;
        const groups = response.data.entityData.groups;
        commit(GeneralMutationTypes.SET_COMPANIES, companies);
        commit(GeneralMutationTypes.SET_SITES, sites);
        commit(GeneralMutationTypes.SET_GROUPS, groups);

        const role = rootGetters.loggedInUser.role;
        if (role === Roles.SiteAdmin) {
          const selectedSite = localStorage.getItem("site");
          if (selectedSite) {
            dispatch(AuthActionTypes.SET_SITE, JSON.parse(selectedSite));
          } else {
            dispatch(AuthActionTypes.SET_SITE, sites[0]);
          }
          if (localStorage.getItem("realRole") == Roles.SiteAdmin || localStorage.getItem("realRole") == Roles.GroupAdmin)
            dispatch(AuthActionTypes.SET_COMPANY, companies[0]);
        }

        if (role === Roles.GroupAdmin) {
          const selectedSite = localStorage.getItem("site");
          if (
            selectedSite &&
            typeof selectedSite !== undefined &&
            selectedSite !== "undefined"
          ) {
            dispatch(AuthActionTypes.SET_SITE, JSON.parse(selectedSite));
          } else {
            dispatch(AuthActionTypes.SET_SITE, sites[0]);
          }
          const selectedGroup = localStorage.getItem("group");
          if (selectedGroup) {
            dispatch(AuthActionTypes.SET_GROUP, JSON.parse(selectedGroup));
          } else {
            dispatch(AuthActionTypes.SET_GROUP, groups[0]);
          }
          if (localStorage.getItem("realRole") == Roles.GroupAdmin)
            dispatch(AuthActionTypes.SET_COMPANY, companies[0]);
        }
      });
    });
  },
  async [GeneralActionTypes.GET_COMPANIES]({ commit }) {
    return new Promise(() => {
      axiosAgsc.get("Company/GetCompanyList", null).then(response => {
        commit(GeneralMutationTypes.SET_COMPANIES, response.data.entityData);
      });
    });
  },
  async [GeneralActionTypes.GET_SITES]({ commit, rootState, dispatch }) {
    return new Promise(() => {
      axiosAgsc.get("Site/GetSites", {}).then(response => {
        commit(GeneralMutationTypes.SET_SITES, response.data.entityData);
        dispatch(AuthActionTypes.SET_SITE, response.data.entityData[0]);
      });
    });
  },
  async [GeneralActionTypes.GET_GROUPS]({ commit, dispatch }) {
    return new Promise(() => {
      axiosAgsc.get("Group/GetGroups", null).then(response => {
        commit(GeneralMutationTypes.SET_GROUPS, response.data.entityData);
        dispatch(AuthActionTypes.SET_GROUP, response.data.entityData[0]);
      });
    });
  },
  async [GeneralActionTypes.GET_SETTINGS]({ commit }, userGuid) {
    return new Promise<void>(resolve => {
      axiosAgsc
        .get("UserSettings/GetUserSettings?userGuid=" + userGuid, null)
        .then(response => {
          commit(GeneralMutationTypes.SET_SETTINGS, response.data.entityData);
          resolve();
        });
    });
  },
  async [GeneralActionTypes.GET_SMTP_SETTINGS]({ commit, rootGetters }) {
    const formData = {
      useGlobal: false,
      companyGuid: "",
    };

    if (rootGetters.company && rootGetters.company.companyGuid) {
      formData.companyGuid = rootGetters.company.companyGuid;
    }

    const role = rootGetters.loggedInUser.role;
    if (role === Roles.AGMSAdmin) {
      formData.useGlobal = true;
    }

    return new Promise<void>(resolve => {
      axiosAgsc
        .get("GlobalSettings/GetSettings?settingKey=email", { params: formData })
        .then(response => {
          commit(
            GeneralMutationTypes.SET_SMTP_SETTINGS,
            response.data.entityData
          );
          resolve();
        });
    });
  },
  async [GeneralActionTypes.GET_GLOBAL_SETTINGS]({ commit, rootGetters }, data) {

    return new Promise<void>(resolve => {
      axiosAgsc
        .get(`GlobalSettings/GetSettings?settingKey=${data}`, {})
        .then((response: any) => {
          resolve(response);
        });
    });
  },
  async [GeneralActionTypes.UPDATE_SETTINGS]({ commit }, data) {
    return new Promise(() => {
      axiosAgsc
        .post("UserSettings/CreateOrUpdateUserSettings", data)
        .then(response => {
          commit(GeneralMutationTypes.SET_SETTINGS, response.data.entityData);
          commit(GeneralMutationTypes.SET_ALERT, {
            status: true,
            options: { type: "success", message: "hashlookupsaved" },
          });
        });
    });
  },
  async [GeneralActionTypes.UPDATE_GLOBAL_SETTINGS](
    { commit, rootGetters },
    data
  ) {
    return new Promise<void>((resolve, reject) => {
      axiosAgsc
        .post(`GlobalSettings/CreateOrUpdateSettings?settingKey=${data.settingsType}`, data)
        .then((response: any) => {
          commit(GeneralMutationTypes.SET_ALERT, {
            status: true,
            options: { type: "success", message: "settingsSaved" },
          });
          resolve(response);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.UPDATE_SMTP_SETTINGS](
    { commit, rootGetters },
    data
  ) {
    data.globalUse = false;
    const role = rootGetters.loggedInUser.role;
    if (role === Roles.AGMSAdmin) {
      data.globalUse = true;
    }

    return new Promise<void>((resolve, reject) => {
      axiosAgsc
        .post("GlobalSettings/CreateOrUpdateSettings?settingKey=email", data)
        .then((response: any) => {
          commit(
            GeneralMutationTypes.SET_SMTP_SETTINGS,
            response.data.entityData
          );
          commit(GeneralMutationTypes.SET_ALERT, {
            status: true,
            options: { type: "success", message: "smtpSettingsSaved" },
          });
          resolve(response);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.UPDATE_REVIEW]({ commit }, data) {
    return new Promise(() => {
      axiosAgsc.put("PolicyReview/UpdateReview", data);
    });
  },
  async [GeneralActionTypes.SET_SELECTED_ROW]({ commit }, data) {
    return new Promise(() => {
      commit(GeneralMutationTypes.SET_SELECTED_ROW, data);
    });
  },
  async [GeneralActionTypes.SET_SCOPE_DETAIL]({ commit }, data) {
    return new Promise(() => {
      commit(GeneralMutationTypes.SET_SCOPE_DETAIL, data);
    });
  },
  [GeneralActionTypes.GET_USERS]({ commit, rootGetters }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      Page: options.page,
      PageSize: options.pageSize,
      SortColumn: options.sortable.order || "",
      SortDir: options.sortable.sort || "",
    };
    if (options.fullTextSearch) {
      query.fullTextSearch = options.fullTextSearch
    }
    const company = localStorage.getItem("company");
    const companyGuid = company ? JSON.parse(company)?.companyGuid : "";
    const partner = localStorage.getItem("partner");
    const partnerGuid = partner ? JSON.parse(partner)?.guid : "";
    const role = rootGetters.loggedInUser.role;

    if (role !== Roles.AGMSAdmin) {
      query.CompanyGuid = companyGuid || "";
    }
    if (role === Roles.PartnerAdmin) {
      query.PartnerId = partnerGuid || "";
    }

    const body = { ...filters, ...query };

    const params = new URLSearchParams(body).toString();
    options.isLoading = true;
    // const response = {"pageIndex":1,"pageSize":5,"totalCount":45,"totalPages":9,"hasPreviousPage":true,"hasNextPage":true,"status":200,"statusCode":200,"isSuccess":true,"message":null,"errors":null,"entityData":[{"id":"3b985544-e077-4b5a-b9d1-214a13a94f76","firstName":"Hakan","lastName":"GroupAdmin","email":"hakanext@appguard.us","role":"Group Administrator","createdAt":"2023-01-12T23:48:29.707752Z","lastLogin":null,"sites":["3475b33e_2e5c_443c_bb67_caadc7d455f6"],"groups":["d8c7db2a-075f-4219-91d3-13bb8c5b48f3"],"companies":["ac7a0657_e6bd_4b54_9b5e_4396d5861b24"]},{"id":"ef4b1efa-b055-4c41-bc70-c13729202889","firstName":"Hakan","lastName":"SiteAdmin","email":"hakan-ext@appguard.us","role":"Site Administrator","createdAt":"2023-01-12T23:47:39.281495Z","lastLogin":null,"sites":["3475b33e_2e5c_443c_bb67_caadc7d455f6"],"groups":["d8c7db2a-075f-4219-91d3-13bb8c5b48f3"],"companies":["ac7a0657_e6bd_4b54_9b5e_4396d5861b24"]},{"id":"fecfdac4-3f1c-47fd-a32e-7735fca639b5","firstName":"Hakan","lastName":"CompanyAdmin","email":"hyaman@appguard.us","role":"Company Administrator","createdAt":"2023-01-12T23:32:57.44681Z","lastLogin":null,"sites":["f1ff256c_d4d6_49bd_b8b9_c75b5fb24381","6cca5d6e_ac26_416c_b649_b5bac0fd92e0","ababc7ae_ec7e_416e_ab69_5d5f9f796872"],"groups":["9ae7880e-4457-496b-8e8c-5cf1452ab376","8ee63e43-8c95-4f35-8fa4-c35fee0570f2","286010bf-1855-4cf6-9e7d-b22c300608c1","dd54c445-04a0-4453-9e63-cca5a8a7b1ce","cc7b1a67-e5dd-41e4-9d66-9570c29f95aa","986c63b1-0999-44a7-ac11-bccb9baeeb7b","448017ce-a8bd-4ea0-a4d8-8ed1120af704","5d00a138-596d-4a2c-9a12-73be19ffd06f","f4976865-7b15-481a-aaff-d0dc4373d6d2","deca5db9-d0ee-4ee8-985f-e436d0d7a9c1","afcb8dc3-9b32-4cbe-87a3-9666470c1c63","90b9be9b-a7ea-4615-8676-b6d4a9fa2a1d","5824baee-b33a-4038-87a9-866f5211a8f5"],"companies":["ac7a0657_e6bd_4b54_9b5e_4396d5861b24"]},{"id":"23e2bf7a-524f-4fc5-a798-37c655564ad6","firstName":"Test","lastName":"Group-2","email":"test-group-blue2@test.us","role":"Group Administrator","createdAt":"2023-01-11T14:26:18.186677Z","lastLogin":"2023-01-11 14:26:40.176338+00","sites":["6cca5d6e_ac26_416c_b649_b5bac0fd92e0"],"groups":["8ee63e43-8c95-4f35-8fa4-c35fee0570f2","286010bf-1855-4cf6-9e7d-b22c300608c1","dd54c445-04a0-4453-9e63-cca5a8a7b1ce"],"companies":["ac7a0657_e6bd_4b54_9b5e_4396d5861b24"]},{"id":"aeff6e88-b412-426b-b275-debc928db3cb","firstName":"Hakan","lastName":"Yaman","email":"hyaman-ext@appguard.us","role":"AGMS Administrator","createdAt":"2022-12-20T08:05:06.405586Z","lastLogin":"2023-01-13 18:49:32.460072+00","sites":[],"groups":[],"companies":[]}],"entityDataCount":0};
    // options.rows = response.entityData;
    // options.total = response.totalCount;
    // commit(GeneralMutationTypes.SET_USERS, response.entityData);

    return apiIDserver
      .get("Users?" + params, null)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
        commit(GeneralMutationTypes.SET_USERS, res.data.entityData);
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_PARTNERS]({ commit, rootGetters }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      pageSize: options.pageSize,
      sortColumn: options.sortable.order || "",
      sortDir: options.sortable.sort || "",
    };

    const body = { ...filters, ...query };
    options.isLoading = true;
    // const response = {"pageIndex":1,"pageSize":10,"totalCount":1,"totalPages":1,"hasPreviousPage":true,"hasNextPage":false,"statusCode":200,"isSuccess":true,"message":null,"entityData":[{"id":"d1b4fc21-69ab-4286-b2b8-b8bcd0606059","name":"Test","shortName":"Test","contactName":"Test","contactPhone":"555555555","contactEmail":"partner@test.com"}],"entityDataCount":1,"errors":null};
    // options.rows = response.entityData;
    // options.total = response.totalCount;
    // commit(GeneralMutationTypes.SET_PARTNERS, response.entityData);

    return axiosAgsc
      .post("Partner/Search", body, {
        headers: { "Content-Type": "application/json" },
      })
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
        commit(GeneralMutationTypes.SET_PARTNERS, res.data.entityData);
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_EVENTS](
    { commit, dispatch, rootState },
    payLoad: any
  ) {
    const filters = payLoad.filters;
    const options = payLoad.options;

    let sortColumn = "ReportedEventDate";

    switch (options.sortable.order) {
      case "seen":
        sortColumn = "ReportedEventDate";
        break;
      case "computer":
        sortColumn = "ComputerName.keyword";
        break;
      case "severity":
        sortColumn = "Severity.keyword";
        break;
      case "user":
        sortColumn = "UserInfo.UserName.keyword";
        break;
      case "action":
        sortColumn = "EventDetails._t.keyword";
        break;
      case "eventCount":
        sortColumn = "Occurrences";
        break;
      case "typeName":
        sortColumn = "Type";
        break;
      case "eventtype":
        sortColumn = "EventDetails._t.keyword";
        break;

      default:
        sortColumn = "ReportedEventDate";
        break;
    }

    const query: any = {
      page: options.page,
      limit: rootState.general.exportStatus ? 1000 : options.pageSize,
      sortColumn: sortColumn || "ReportedEventDate",
      sortDir: options.sortable.sort || null,
    };

    const body = { ...filters, ...query };

    body.startDate = moment(body.startDate);
    body.endDate = moment(body.endDate);

    options.isLoading = true;
    return axiosAgsc
      .post("Event/GetEventInspectionPageData", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
        if (res.data.message) {
          options.message = res.data.message;
        } else {
          options.message = null;
        }
        if (rootState.general.exportStatus) {
          setTimeout(() => {
            dispatch(GeneralActionTypes.SET_EXPORT_DATA_LOADED, true);
          }, 300);
        }
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_EVENT_LISTS]({ commit, rootState }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
      sortColumn: "ReportedEventDate",
      sortDir: options.sortable.sort || null,
    };
    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .post("PolicyReview/IndividualProposedUniqueBlocks", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.entityDataCount ? res.data.entityDataCount : 0;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },

  [GeneralActionTypes.GET_ALERTS]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
      sortColumn: options.sortable.order || "",
      sortDir: options.sortable.sort || "",
    };

    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .post("Alarm/ListAlarms", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_ASSETS]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
      sortColumn: options.sortable.order || "",
      sortDir: options.sortable.sort || "",
    };
    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .get("Dashboard/GetCompanyAssets", { params: filters })
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.entityData.length;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_ASSET_SITES]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
      sortColumn: options.sortable.order || "",
      sortDir: options.sortable.sort || "",
    };
    const body = { ...filters, ...query };
    options.isLoading = true;

    return axiosAgsc
      .get("Dashboard/GetSiteAssets?companyGuid=" + filters.guid, body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.entityData.length;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_ASSET_GROUPS]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
      sortColumn: options.sortable.order || "",
      sortDir: options.sortable.sort || "",
    };
    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .get("Dashboard/GetGroupAssets?siteGuid=" + filters.guid, body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.entityData.length;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_ASSET_COMPUTERS]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
      sortField: options.sortable.order || "",
      ascending: options.sortable && options.sortable.sort == 'asc' ? true : false,
    };
    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .post("Dashboard/GetGroupAssetsWithComputer", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.DELETE_ASSET_COMPUTERS]({ commit }, payLoad: any) {
    return new Promise<void>(resolve => {
      axiosAgsc
        .delete("Computer/DeleteComputer?computerId=" + payLoad)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  [GeneralActionTypes.GET_COMPUTER_LIST]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
      sortColumn: options.sortable.order || "",
      sortDir: options.sortable.sort || "",
    };
    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .post("Computer/GetActiveOrOffileneComputers", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_COMPUTER_LIST_BY_USER]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
      sortField: options.sortable.order || "",
      ascending:
        options.sortable.sort && options.sortable.sort == "asc" ? true : false,
    };

    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .post("Dashboard/GetComputerBrowseAsset", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_HASHES](
    { commit, rootState, dispatch },
    payLoad: any
  ) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: rootState.general.exportStatus ? 1000 : options.pageSize,
      sortField: options.sortable.order || "",
      sortDir: options.sortable.sort || "",
    };

    const body = { ...filters, ...query };
    options.isLoading = true;
    const url = "HashInspection/GetHashInformationAllHash";
    if (options.loadType === "filter") {
      // url = 'HashInspection/GetHashInformationPage';
    }
    return axiosAgsc
      .post(url, body)
      .then(res => {
        const rows =
          res.data.entityData &&
            res.data.entityData.length &&
            res.data.entityData[0].hash &&
            res.data.entityData[0].hash != null
            ? res.data.entityData
            : [];
        options.rows = rows;
        options.total = res.data.totalCount ? res.data.totalCount : 0;
        if (rootState.general.exportStatus) {
          setTimeout(() => {
            dispatch(GeneralActionTypes.SET_EXPORT_DATA_LOADED, true);
          }, 300);
        }
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_PROPOSED_UNIQUE_BLOCKS]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
      sortColumn: options.sortable.order || "",
      sortDir: options.sortable.sort || "",
    };
    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .post("PolicyReview/ProposedUniqueBlocks", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_AUDITS]({ commit, rootState }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      limit: payLoad.options.pageSize,
      page: payLoad.options.page,
    };
    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .post("Agsc/GetAuditLogs", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  async [GeneralActionTypes.GET_PERMISSION_LEVELS]({ commit }) {
    return new Promise<void>(resolve => {
      axiosAgsc.get("PolicyReview/GetPermissionLevels", null).then(response => {
        commit(
          GeneralMutationTypes.SET_PERMISSION_LEVELS,
          response.data.entityData
        );
        resolve(response.data.entityData);
      });
    });
  },
  async [GeneralActionTypes.GET_REVIEW_STATUSES]({ commit }) {
    return new Promise<void>(resolve => {
      axiosAgsc.get("PolicyReview/GetReviewStatuses", null).then(response => {
        commit(
          GeneralMutationTypes.SET_REVIEW_STATUSES,
          response.data.entityData
        );
        resolve(response.data.entityData);
      });
    });
  },
  async [GeneralActionTypes.GET_RISK_LEVELS]({ commit }) {
    return new Promise<void>(resolve => {
      axiosAgsc.get("PolicyReview/GetRiskLevels", null).then(response => {
        commit(GeneralMutationTypes.SET_RISK_LEVELS, response.data.entityData);
        resolve(response.data.entityData);
      });
    });
  },
  async [GeneralActionTypes.CREATE_REVIEW]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.post("PolicyReview/CreateReview", data).then(response => {
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.CREATE_UNIQUE_BLOCK_REVIEW]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .post("PolicyReview/AddUniqueBlockToReviewCheckList", data)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.UPDATE_REVIEW_CHECKLIST_ITEM]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .post("PolicyReview/UpdateReviewCheckListItem", data)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  [GeneralActionTypes.GET_POLICY_CHECK_LIST]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
    };
    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .post("PolicyReview/ListCheckList", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  [GeneralActionTypes.GET_REVIEW_CHECK_LIST]({ commit }, payLoad: any) {
    const filters = payLoad.filters;
    const options = payLoad.options;
    const query: any = {
      page: options.page,
      limit: options.pageSize,
    };
    const body = { ...filters, ...query };
    options.isLoading = true;
    return axiosAgsc
      .post("PolicyReview/ListReviewCheckList", body)
      .then(res => {
        options.rows = res.data.entityData ? res.data.entityData : [];
        options.total = res.data.totalCount ? res.data.totalCount : 0;
      })
      .finally(() => {
        options.isLoading = false;
      });
  },
  async [GeneralActionTypes.CREATE_OTP]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.post("Computer/GenerateOtp", data).then(response => {
        resolve(response.data);
      });
    });
  },
  [GeneralActionTypes.SET_ISCREATED_MODAL]({ commit }, payLoad: any) {
    commit("SET_ISCREATED_MODAL", payLoad);
  },
  [GeneralActionTypes.SET_SCOPE_MODAL]({ commit }, payLoad: any) {
    commit("SET_SCOPE_MODAL", payLoad);
  },
  async [GeneralActionTypes.CREATE_OR_EDIT_COMPANY]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.post("Company/CreateOrEditCompany", data).then(response => {
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.DELETE_COMPANY]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.post("Company/DeleteCompany", data).then(response => {
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.GET_IGNORE_EVENT_LIST]({ commit }, groupId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("agms/IgnoreEvents/GetIgnoreEventList?mainid=" + groupId, null)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.GET_TEMPLATE_IGNORE_EVENT_LIST]({ commit }, templateId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("agms/TemplatePolicy/GetTemplateIgnoreEventList?templateId=" + templateId, null)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.GET_SEVERITY_EVENT_LIST]({ commit }, groupId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("agms/SeverityEvents/GetSeverityEventList?mainId=" + groupId, null)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.GET_TEMPLATE_SEVERITY_EVENT_LIST]({ commit }, templateId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("agms/TemplatePolicy/GetTemplateSeverityEventList?templateId=" + templateId, null)
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.GET_EVENT_POLICY_NAME]({ commit }, { mainId, ruleId, ruleSource,ruleName,targetPath }) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get(`agms/EventPolicy/GetEventPolicyName?mainId=${mainId}&ruleId=${ruleId}&ruleSource=${ruleSource}&ruleName=${ruleName}&targetPath=${targetPath}`, null)
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_GLOBAL_SERVER]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.post("Server/GetGlobalServers", data).then(response => {
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.GET_SERVERS]({ commit }, payLoad: any) {
    const selectedRole = localStorage.getItem("selectedRole");
    const realRole = localStorage.getItem("realRole");
    const selectedScopeId = localStorage.getItem("selectedScopeId");
    const partner = localStorage.getItem("partner");
    const partnerGuid = partner ? JSON.parse(partner)?.guid : "";
    const company = localStorage.getItem("company");
    const companyGuid = company ? JSON.parse(company)?.companyGuid : "";
    const site = localStorage.getItem("site");
    const siteGuid = site ? JSON.parse(site)?.key : "";
    const group = localStorage.getItem("group");
    const groupGuid = group ? JSON.parse(group)?.key : "";

    const filters = {
      ...payLoad.filters,
      PdpLrpPageRole: selectedRole,
      SelectedScopeId: selectedScopeId,
      PartnerId: partnerGuid,
      CompanyId: companyGuid,
      SiteId: siteGuid,
      GroupId: groupGuid
    };

    const options = payLoad.options;
    const query: any = {
      limit: payLoad.options.pageSize,
      page: payLoad.options.page,
    };
    const body = { ...filters, ...query };
    options.isLoading = true;

    return new Promise<any>(resolve => {
      axiosAgsc
        .post("Server/GetServers", body)
        .then(res => {
          options.rows = res.data.entityData ? res.data.entityData : [];
          options.total = res.data.totalCount ? res.data.totalCount : 0;
          resolve(res.data);
        })
        .finally(() => {
          options.isLoading = false;
        });
    });
  },

  async [GeneralActionTypes.DELETE_SERVER]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.post("Server/DeleteServer", data).then(response => {
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.DELETE_SELECT_SERVER]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.post("Server/DeleteSelectServer", data).then(response => {
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.GET_ZONES]({ commit }) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("Server/GetZones", null)
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_SERVER_BY_ID]({ commit }, id) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get('Server/GetServerById', { params: { id } })
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_COMPANY_SERVER_BY_ID]({ commit }, { id, companyGuid }) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get('Server/GetCompanyServerById', {
          params: {
            id,
            companyGuid
          }
        })
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.CREATE_OR_UPDATE_SERVER]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.post("Server/CreateOrUpdateServer", data).then(response => {
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.SELECT_OR_INHERIT_SERVER]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.post("Server/SelectOrInheritServer", data).then(response => {
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.GET_TEST_CONNECTION_BY_SERVERID]({ commit }, data) {
    return new Promise<any>((resolve) => {
      axiosAgsc.post(`Server/TestConnectionByServerId`, data).then(response => {
        resolve(response.data);
      })
    });
  },
  async [GeneralActionTypes.TEST_CONNECTION]({ commit }, data) {
    return new Promise<any>((resolve) => {
      axiosAgsc.post(`Server/TestConnection`, data).then(response => {
        resolve(response.data);
      })
    });
  },
  async [GeneralActionTypes.UPDATE_APPGUARD_MAIN]({ commit }, data) {
    return new Promise<any>((resolve) => {
      axiosAgsc.post(`AppGuardMain/UpdateAppGuardMain`, data).then(response => {
        resolve(response.data);
      })
    });
  },

  async [GeneralActionTypes.GET_OR_CREATE_APPGUARD_MAIN]({ commit }, { companyId, selectedRole, realRole, selectedScopeId }) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get('AppGuardMain/GetOrCreateDefaultAppGuardMain', {
          params: {
            companyId,
            selectedRole,
            realRole,
            selectedScopeId
          }
        })
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.RESET_TO_DEFAULT_APPGUARD_MAIN]({ commit }, data) {
    return new Promise<any>((resolve) => {
      axiosAgsc.post(`AppGuardMain/ResetToDefaultAppGuardMain`, data).then(response => {
        resolve(response.data);
      })
    });
  },
  async [GeneralActionTypes.EDIT_PROCESS]({ commit }, data) {
    console.log("edit")
  },

  async [GeneralActionTypes.GET_APPGROUPS]({ commit }, data) {
    const group = localStorage.getItem("group");
    const groupId = group ? JSON.parse(group)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/AppGroup/GetAllAppGroups?groupId=" + groupId, { data }).then(response => {
        commit(GeneralMutationTypes.SET_APPGROUPS, response.data.entityData);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/AppGroup/CreateOrUpdateAppGroup", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_DETAIL]({ commit }, groupId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/AppGroup/GetAppGroupDetail?appGroupId=" + groupId, {})
        .then(response => {
          commit(GeneralMutationTypes.SET_APPGROUP_INFO, response.data.entityData);
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.EXPORT_APPGROUP]({ commit }, appGroupId) {
    const response = await axiosAgsc.get(
      `/agms/AppGroup/ExportAppGroup?appGroupId=${appGroupId}`,
      { responseType: "blob" } 
    );

    return response.data; 
  },
  async [GeneralActionTypes.IMPORT_APPGROUP]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc
        .post("/agms/AppGroup/ImportAppGroup", data, {
          headers: { "Content-Type": "application/json" }
        })
        .then(response => resolve(response.data))
        .catch(err => reject(err));
    });
  },

  async [GeneralActionTypes.DELETE_APPGROUP]({ commit }, groupId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/AppGroup/DeleteAppGroup?appGroupId=" + groupId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_REGISTRY]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/AppGroup/GetAllAppGroupRegistriesByAppGroupId?appGroupId=" + appGroupId, {})
      .then(response => {
        commit(GeneralMutationTypes.SET_APPGROUPS_REGISTRY_ACCESS, response.data.entityData);
        resolve(response.data.entityData);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_REGISTRY]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/AppGroup/CreateOrUpdateAppGroupRegistry", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_REGISTRY_DETAIL]({ commit }, groupId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/AppGroup/GetAppGroupRegistry?appGroupRegistryId=" + groupId, null)
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_CODE_LOAD]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/AppGroup/GetAllAppGroupCodeLoadsByAppGroupId?appGroupId=" + appGroupId, { })
      .then(response => {
        commit(GeneralMutationTypes.SET_APPGROUPS_CODE_LOAD, response.data.entityData);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CODE_LOAD]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/AppGroup/CreateOrUpdateAppGroupCodeLoad", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_CODE_LOAD_DETAIL]({ commit }, appGroupCodeLoadId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/AppGroup/GetAppGroupCodeLoad?appGroupCodeLoadId=" + appGroupCodeLoadId, {})
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_CHILD_LAUNCH]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/AppGroup/GetAllAppGroupChildLaunchesByAppGroupId?appGroupId=" + appGroupId, { })
      .then(response => {
        commit(GeneralMutationTypes.SET_APPGROUPS_CHILD_LAUNCH, response.data.entityData);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/AppGroup/CreateOrUpdateAppGroupChildLaunch", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_CHILD_LAUNCH_DETAIL]({ commit }, appGroupChildLaunchId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/AppGroup/GetAppGroupChildLaunch?appGroupChildLaunchId=" + appGroupChildLaunchId, {})
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS]({ commit }, data) {
    return new Promise<any>((resolve,reject) => {
      axiosAgsc.post("/agms/AppGroup/CreateOrUpdateAppGroupFileAccess", data).then(response => {
        resolve(response.data);
      })
      .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_FILE_ACCESS]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/AppGroup/GetAllAppGroupFileAccessesByAppGroupId?appGroupId=" + appGroupId, { })
      .then(response => {
        commit(GeneralMutationTypes.SET_APPGROUPS_FILE_ACCESS, response.data.entityData);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_FILE_ACCESS_DETAIL]({ commit }, appGroupFileAccessId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/AppGroup/GetAppGroupFileAccess?appGroupFileAccessId=" + appGroupFileAccessId, {})
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_PROCESS]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/AppGroup/GetAllAppGroupProcessByAppGroupId?appGroupId=" + appGroupId, { })
      .then(response => {
        commit(GeneralMutationTypes.SET_APPGROUPS_PROCESS, response.data.entityData);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_PROCESS]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/AppGroup/CreateOrUpdateAppGroupProcess", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_PROCESS_DETAIL]({ commit }, appGroupProcessId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/AppGroup/GetAppGroupProcess?appGroupProcessId=1" + appGroupProcessId, {})
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_FOLDER_MAPS]({ commit }, data) {
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/CatalogData/GetFolderMaps", data).then(response => {
        if (response.data?.isSuccess && response.data.entityData) {
          const sortedData = response.data.entityData.sort((a: { name: string; id: number; mapPath:string }, b: { name: string; id: number; mapPath:string }) => a.name.localeCompare(b.name));
          const folderOptions = sortedData.map((folder: { name: string; id: number; mapPath:string }) => ({
            label: folder.name,
            value: folder.id,
            mapPath: folder.mapPath
          }));
          commit(GeneralMutationTypes.SET_FOLDER_MAPS, folderOptions);
        }
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.GET_ENUM_BY_NAME]({ commit }, name) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/CatalogData/GetEnumByName?name=" + name, {})
        .then(response => {
          resolve(response.data);
          const formatted = Object.entries(response.data.entityData).map(([key, value]) => ({
            label: key,
            value: value as string | number
          }));
          commit(GeneralMutationTypes.SET_ENUM, {
            name,
            data: formatted
          });
        });
    });
  },

  async [GeneralActionTypes.DELETE_APPGROUP_CHILD_LAUNCH]({ commit }, appGroupChildLaunchId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/AppGroup/DeleteAppGroupChildLaunch?appGroupChildLaunchId=" + appGroupChildLaunchId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.DELETE_APPGROUP_REGISTRY_ACCESS]({ commit }, appGroupRegistryId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/AppGroup/DeleteAppGroupRegistry?appGroupRegistryId=" + appGroupRegistryId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.DELETE_APPGROUP_FILE_ACCESS]({ commit }, appGroupFileAccessId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/AppGroup/DeleteAppGroupFileAccess?appGroupFileAccessId=" + appGroupFileAccessId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.DELETE_APPGROUP_CODE_LOAD]({ commit }, appGroupCodeLoadId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/AppGroup/DeleteAppGroupCodeLoad?appGroupCodeLoadId=" + appGroupCodeLoadId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_PUBLISHER_LIST]({ commit }, mainId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/Publisher/GetPublisherList?mainId=" + mainId, null)
        .then(response => {
          if (response.data?.isSuccess && response.data.entityData) {
            const publisherOptions = response.data.entityData.map((folder: { name: string; id: number }) => ({
              label: folder.name,
              value: folder.id
            }));
            commit(GeneralMutationTypes.SET_PUBLISHER_LIST, publisherOptions);
          }
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_ALL_GLOBAL_POLICY]({ commit }, groupId) {
    // const group = localStorage.getItem("group");
    // const groupGuid = group ? JSON.parse(group)?.key : "";

    const group = localStorage.getItem("group");
    groupId = group ? JSON.parse(group)?.mainid : null;

    return new Promise<any>(resolve => {
      console.log("groupId", groupId);
      axiosAgsc.get("/agms/GlobalPolicy/GetAllGlobalPolicies?groupId=" + groupId, null).then(response => {
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS]({ commit }, groupId) {
    const group = localStorage.getItem("group");
    groupId = group ? JSON.parse(group)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/GlobalPolicy/GetAllGlobalPolicyFiles?groupId=" + groupId, null).then(response => {
        commit(GeneralMutationTypes.SET_GLOBAL_POLICY_FILE_ACCESS, response.data.entityData);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS_DETAIL]({ commit }, globalPolicyFileId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/GlobalPolicy/GetGlobalPolicyFile?globalPolicyFileId=" + globalPolicyFileId, {})
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_GLOBAL_POLICY_REGISTRY_ACCESS]({ commit }, groupId) {
    const group = localStorage.getItem("group");
    groupId = group ? JSON.parse(group)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/GlobalPolicy/GetAllGlobalPolicyRegistries?groupId=" + groupId, null).then(response => {
        commit(GeneralMutationTypes.SET_GLOBAL_POLICY_REGISTRY_ACCESS, response.data.entityData);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.GET_GLOBAL_POLICY_REGISTRY_ACCESS_DETAIL]({ commit }, globalPolicyRegistryId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/GlobalPolicy/GetGlobalPolicyRegistry?globalPolicyRegistryId=" + globalPolicyRegistryId, {})
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/GlobalPolicy/CreateOrUpdateGlobalPolicyRegistry", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/GlobalPolicy/CreateOrUpdateGlobalPolicyFile", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.DELETE_GLOBAL_POLICY_FILE_ACCESS]({ commit }, globalPolicyFileId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/GlobalPolicy/DeleteGlobalPolicyFile?globalPolicyFileId=" + globalPolicyFileId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.DELETE_GLOBAL_POLICY_REGISTRY]({ commit }, globalPolicyRegistryId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/GlobalPolicy/DeleteGlobalPolicyRegistry?globalPolicyRegistryId=" + globalPolicyRegistryId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.DELETE_APPGROUP_PROCESS]({ commit }, appGroupProcessId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/AppGroup/DeleteAppGroupProcess?appGroupProcessId=" + appGroupProcessId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/GlobalPolicy/CreateOrUpdateGlobalPolicyCodeLoad", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_GLOBAL_POLICY_CODE_LOAD]({ commit }, groupId) {
    const group = localStorage.getItem("group");
    groupId = group ? JSON.parse(group)?.mainid : null;

    return new Promise<any>(resolve => {
       axiosAgsc.get("/agms/GlobalPolicy/GetAllGlobalPolicyCodeLoads?groupId="+groupId,null).then(response => {
        commit(GeneralMutationTypes.SET_GLOBAL_POLICY_CODE_LOAD, response.data.entityData);
        resolve(response.data);
      });
    });
  },

   async [GeneralActionTypes.DELETE_GLOBAL_POLICY_CODE_LOAD]({ commit }, globalPolicyCodeLoadId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/GlobalPolicy/DeleteGlobalPolicyCodeLoad?globalPolicyCodeLoadId="+globalPolicyCodeLoadId 
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES]({ commit }, data) {
    const group = localStorage.getItem("group");
    const groupId = group ? JSON.parse(group)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/FileTypesPolicy/GetAllFileTypesPolicies?groupId=" + groupId, { data }).then(response => {
        const data = response.data.entityData;
        const transformed = data.flatMap((policy: any) =>
          policy.fileExtensionDaos.map((dao: any) => ({
            fileExtension: dao.fileExtension,
            driverActionOverride: dao.driverActionOverride,
            fileTypePolicyName: policy.name,
            fileExtensionApps: policy.fileExtensionApps,
            fileTypesPolicyDaoId: dao.id,
            id:policy.id,
            enabled: policy.enabled
          }))
        );
        console.log("transformed data:", transformed)
        commit(GeneralMutationTypes.SET_FILE_TYPES_POLICIES, transformed);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_FILE_TYPES_POLICY]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/FileTypesPolicy/CreateOrUpdateFileTypesPolicy", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_FILE_TYPES_POLICY_DETAIL]({ commit }, fileTypesPolicyId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/FileTypesPolicy/GetFileTypesPolicy?fileTypesPolicyId=" + fileTypesPolicyId, {})
        .then(response => {
          resolve(response.data);
        });
    });
  },

  async [GeneralActionTypes.DELETE_FILE_TYPES_POLICY]({ commit }, fileTypesPolicyId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/FileTypesPolicy/DeleteFileTypesPolicy?fileTypesPolicyId=" + fileTypesPolicyId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.GET_ALL_FILE_TYPES_POLICIES_TEMPLATE]({ commit }, data) {
    const template = localStorage.getItem("agms_template");
    const templateId = template ? JSON.parse(template)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc
        .get(`/agms/TemplatePolicy/GetTemplateFileTypeList?templateId=${templateId}`, { data })
        .then(response => {
          const list = response.data?.entityData?.templatePolicyViewModel || [];
          const transformed = list.flatMap((policy: any) => {
            const fx = policy?.fileExtensions || {};
            const daos = fx?.fileExtensionDaos || [];
            return daos.map((dao: any) => ({
              fileExtension: dao.fileExtension,
              driverActionOverride: dao.driverActionOverride,
              fileTypePolicyName: fx.name,
              fileExtensionApps: fx.fileExtensionApps || [],
              fileExtensionId: fx.id,
              Id: dao.id,
              enabled: policy.enabled,
            }));
          });

          commit(GeneralMutationTypes.SET_FILE_TYPES_POLICIES, transformed);
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.GET_FILE_TYPES_POLICY_DETAIL_TEMPLATE]({ commit }, fileTypesPolicyId) {
    const template = localStorage.getItem("agms_template");
    const templateId = template ? JSON.parse(template)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc
        .get("/agms/TemplatePolicy/GetTemplateFileTypesPolicy?templateId=" + templateId + "&fileTypesPolicyId=" + fileTypesPolicyId, {})
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.CREATE_OR_UPDATE_FILE_TYPES_POLICY_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateFileTypesPolicy", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.DELETE_FILE_TYPES_POLICY_DAO_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteFileTypesPolicyDAO", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.DELETE_FILE_TYPES_POLICY_DAO]({ commit }, fileTypesPolicyDaoId) {
    return new Promise<any>(resolve => {
      axiosAgsc
        .delete("/agms/FileTypesPolicy/DeleteFileTypesPolicyDAO?fileTypesPolicyDaoId=" + fileTypesPolicyDaoId
        )
        .then(response => {
          resolve(response.data);
        });
    });
  },
  async [GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE]({ commit }, groupId) {
    const template = localStorage.getItem("agms_template");
    const templateId = template ? JSON.parse(template)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/TemplatePolicy/GetTemplateGlobalPolicyFileList?templateId=" + templateId, null).then(response => {
        const vm = response.data?.entityData?.templatePolicyViewModel || {};
        const gp = vm?.globalPolicy || {};
        const files = gp?.globalPolicyFile || [];
        const mapped = files.map((item: any) => ({
          ...item,
        }));
        commit(GeneralMutationTypes.SET_GLOBAL_POLICY_FILE_ACCESS, mapped);
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.GET_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE]({ commit }, groupId) {
    const template = localStorage.getItem("agms_template");
    const templateId = template ? JSON.parse(template)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/TemplatePolicy/GetTemplateGlobalPolicyRegistryList?templateId=" + templateId, null).then(response => {
        const vm = response.data?.entityData?.templatePolicyViewModel || {};
        const gp = vm?.globalPolicy || {};
        const files = gp?.globalPolicyRegistry || [];
        const mapped = files.map((item: any) => ({
          ...item,
        }));
        commit(GeneralMutationTypes.SET_GLOBAL_POLICY_REGISTRY_ACCESS, mapped);
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.GET_GLOBAL_POLICY_CODE_LOAD_TEMPLATE]({ commit }, groupId) {
    const template = localStorage.getItem("agms_template");
    const templateId = template ? JSON.parse(template)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/TemplatePolicy/GetTemplateGlobalPolicyCodeLoadList?templateId=" + templateId, null).then(response => {
        const vm = response.data?.entityData?.templatePolicyViewModel || {};
        const gp = vm?.globalPolicy || {};
        const files = gp?.globalPolicyCodeLoad || [];
        const mapped = files.map((item: any) => ({
          ...item,
        }));
        commit(GeneralMutationTypes.SET_GLOBAL_POLICY_CODE_LOAD, mapped);
        resolve(response.data);
      });
    });
  },
  async [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateGlobalPolicyFile", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateGlobalPolicyRegistry", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.CREATE_OR_UPDATE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateGlobalPolicyCodeLoad", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.DELETE_GLOBAL_POLICY_FILE_ACCESS_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteGlobalPolicyFile", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.DELETE_GLOBAL_POLICY_REGISTRY_ACCESS_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteGlobalPolicyRegistry", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.DELETE_GLOBAL_POLICY_CODE_LOAD_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteGlobalPolicyCodeLoad", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUPS_TEMPLATE]({ commit }, data) {
    const template = localStorage.getItem("agms_template");
    const templateId = template ? JSON.parse(template)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/TemplatePolicy/GetTemplateAppGroupList?templateId=" + templateId, { data }).then(response => {
        const entity = response.data?.entityData || {};
        const list = entity.templatePolicyListViewModel || [];
        const mapped = list
          .filter((policy: any) => policy?.appGroup)
          .map((policy: any) => ({
            ...policy.appGroup
          }));
        commit(GeneralMutationTypes.SET_APPGROUPS, mapped);
         resolve(response.data);
       });
     });
   },

  async [GeneralActionTypes.GET_APPGROUP_DETAIL_TEMPLATE]({ commit }, appGroupId) {
    const template = localStorage.getItem("agms_template");
    const templateId = template ? JSON.parse(template)?.mainid : null;
    return new Promise<any>(resolve => {
      axiosAgsc.get("/agms/TemplatePolicy/GetTemplateAppGroupDetail?templateId=" + templateId + "&appGroupId=" + appGroupId, { })
      .then(response => {
        commit(GeneralMutationTypes.SET_APPGROUP_INFO, response.data.entityData.templatePolicyViewModel.appGroup);
        resolve(response.data);
      });
     });
   },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateAppGroup", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.DELETE_APPGROUP_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteAppGroup", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.GET_APPGROUP_PROCESS_TEMPLATE]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      const template = localStorage.getItem("agms_template");
      const templateId = template ? JSON.parse(template)?.mainid : null;
      axiosAgsc.get("agms/TemplatePolicy/GetTemplateAppGroupProcessList?templateId=" + templateId +"&appGroupId=" + appGroupId, { })
      .then(response => {
        const vm = response.data?.entityData?.templatePolicyViewModel || {};
        const ag = vm?.appGroup || {};
        const files = ag?.appGroupProcess || [];
        const mapped = files.map((item: any) => ({
          ...item,
        }));
        commit(GeneralMutationTypes.SET_APPGROUPS_PROCESS,mapped);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_PROCESS_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateAppGroupProcess", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },

  async [GeneralActionTypes.DELETE_APPGROUP_PROCESS_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteAppGroupProcess", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.GET_APPGROUP_FILE_ACCESS_TEMPLATE]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      const template = localStorage.getItem("agms_template");
      const templateId = template ? JSON.parse(template)?.mainid : null;
      axiosAgsc.get("/agms/TemplatePolicy/GetTemplateAppGroupFileAccessList?templateId=" + templateId +"&appGroupId=" + appGroupId, { })
      .then(response => {
        const vm = response.data?.entityData?.templatePolicyViewModel || {};
        const ag = vm?.appGroup || {};
        const files = ag?.appGroupFileAccess || [];
        const mapped = files.map((item: any) => ({
          ...item,
        }));
        commit(GeneralMutationTypes.SET_APPGROUPS_FILE_ACCESS, mapped);
        resolve(response.data);
      });
    });
  },
  
  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_FILE_ACCESS_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve,reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateAppGroupFileAccess", data).then(response => {
        resolve(response.data);
      })
      .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.DELETE_APPGROUP_FILE_ACCESS_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteAppGroupFileAccess", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.GET_APPGROUP_REGISTRY_TEMPLATE]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      const template = localStorage.getItem("agms_template");
      const templateId = template ? JSON.parse(template)?.mainid : null;
      axiosAgsc.get("/agms/TemplatePolicy/GetTemplateAppGroupRegistryList?templateId=" + templateId +"&appGroupId=" + appGroupId, {})
      .then(response => {
        const vm = response.data?.entityData?.templatePolicyViewModel || {};
        const ag = vm?.appGroup || {};
        const files = ag?.appGroupRegistry || [];
        const mapped = files.map((item: any) => ({
          ...item,
        }));
        commit(GeneralMutationTypes.SET_APPGROUPS_REGISTRY_ACCESS, mapped);
        resolve(response.data.entityData);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_REGISTRY_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateAppGroupRegistry", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.DELETE_APPGROUP_REGISTRY_ACCESS_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteAppGroupRegistry", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.GET_APPGROUP_CODE_LOAD_TEMPLATE]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      const template = localStorage.getItem("agms_template");
      const templateId = template ? JSON.parse(template)?.mainid : null;
      axiosAgsc.get("/agms/TemplatePolicy/GetTemplateAppGroupCodeLoadList?templateId=" + templateId +"&appGroupId=" + appGroupId, { })
      .then(response => {
        const vm = response.data?.entityData?.templatePolicyViewModel || {};
        const ag = vm?.appGroup || {};
        const files = ag?.appGroupCodeLoad || [];
        const mapped = files.map((item: any) => ({
          ...item,
        }));
        commit(GeneralMutationTypes.SET_APPGROUPS_CODE_LOAD, mapped);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CODE_LOAD_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateAppGroupCodeLoad", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.DELETE_APPGROUP_CODE_LOAD_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteAppGroupCodeLoad", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.GET_APPGROUP_CHILD_LAUNCH_TEMPLATE]({ commit }, appGroupId) {
    return new Promise<any>(resolve => {
      const template = localStorage.getItem("agms_template");
      const templateId = template ? JSON.parse(template)?.mainid : null;
      axiosAgsc.get("/agms/TemplatePolicy/GetTemplateAppGroupChildLaunchList?templateId=" + templateId +"&appGroupId=" + appGroupId, { })
      .then(response => {
        const vm = response.data?.entityData?.templatePolicyViewModel || {};
        const ag = vm?.appGroup || {};
        const files = ag?.appGroupChildLaunch || [];
        const mapped = files.map((item: any) => ({
          ...item,
        }));
        commit(GeneralMutationTypes.SET_APPGROUPS_CHILD_LAUNCH, mapped);
        resolve(response.data);
      });
    });
  },

  async [GeneralActionTypes.CREATE_OR_UPDATE_APPGROUP_CHILD_LAUNCH_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/CreateOrUpdateAppGroupChildLaunch", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  async [GeneralActionTypes.DELETE_APPGROUP_CHILD_LAUNCH_TEMPLATE]({ commit }, data) {
    return new Promise<any>((resolve, reject) => {
      axiosAgsc.post("/agms/TemplatePolicy/DeleteAppGroupChildLaunch", data).then(response => {
        resolve(response.data);
      })
        .catch((err: any) => {
          reject(err);
        });
    });
  },


};
